import { gql } from 'graphql-request'

export const GET_WRITER = gql`
  query Writer($id: Int!) {
    writer(id: $id) {
      id
      bankAccounts {
        id
        bankName
        bankBranch
        bankProvince
        accountNumber
        accountName
        accountType
        bankCoverImgPath
      }
      type
      affiliation
      fullName
      idNumber
      email
      phoneNumber
      residence
      country
      address
      postcode
      province
      district
      subDistrict
      idCardImgPath
      isSameMainAddress
      sendResidence
      sendCountry
      sendAddress
      sendPostcode
      sendProvince
      sendDistrict
      sendSubDistrict
      certificationTax
      companyName
      taxId
      companyCertificateImgPath
      vatRegistrationCertificateImgPath
      coordinatorFullName
      coordinatorEmail
      coordinatorPhoneNumber
      accountingFullName
      accountingEmail
      accountingPhoneNumber
      certificateCountry
      certificateAddress
      certificatePostcode
      certificateProvince
      certificateDistrict
      certificateSubDistrict
      writersConsents {
        consent {
          id
          name
          content
        }
      }
      status
      rejectedReason
      approvedAt
      rejectedAt
      approver {
        id
        displayName
        avatarImgPath
      }
      user {
        id
        avatarImgPath
        idNumber
        fullName
        email
        phoneNumber
        birthDay
        gender
        username
        displayName
        idCardImgPath
      }
    }
  }
`
